// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BadgesG2_wrapper__3qChV","list":"BadgesG2_list__i0QJF","item":"BadgesG2_item__Oki4d","image":"BadgesG2_image__ybaAr","button":"BadgesG2_button__nVSXN"};